import { useEffect } from "react";
import { change } from "redux-form";
import { classActions } from "redux/slices/class";
import ClassService from "services/class.service";
import SelectRedux from "components/molecules/SelectRedux";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { zoneActions } from "redux/slices/zone";
import { pricingActions } from "redux/slices/pricing";

export default function SelectZoneClass(props: any) {
  const { form } = props.meta;
  const dispatch = useAppDispatch();
  const classesOptions = useAppSelector((state) => state.class.classesOptions);
  const classesByZone = useAppSelector((state) => state.class.classesByZone);
  const zone = useAppSelector((state) => state.zone.zone);
  const booking = useAppSelector((state) => state.booking.booking);
  const class_id = useAppSelector((state) => state.form?.[form]?.values?.class_id);
  // const zone_id = useAppSelector((state) => state.form?.[form]?.values?.zone_id);


  useEffect(() => {

    ClassService.getAllClasses();

    return () => {
      dispatch(classActions.clear());
      dispatch(zoneActions.clear());
    };
  }, [dispatch]);

  useEffect(() => {

    if (form == 'AddQuotationForm') {
      dispatch(classActions.setClassesOptionsByZoneId('64fb1c3537a2a1b4fa9b907c'));
    } else {
      if (booking) {
        if (class_id !== booking?.class_id) {
          const form_b = "AddBookingForm";
          dispatch(classActions.setClassesOptionsByZoneId(booking?.zone_id));
          dispatch(change(form_b, "class_id", booking?.class_id));
        }

      }
      else {
        if (form !== "AddBookingForm") dispatch(change(form, "class_id", ""));
        dispatch(classActions.setClassesOptionsByZoneId(zone?._id));
      }
    }
  }, [form, zone, classesByZone, booking, dispatch]);


  return <SelectRedux {...props} options={classesOptions} />;
}
